import API from "../../api/api";
import React, { Component } from "react";
import { States } from "../../components";
import "../../styles/css/Jobs/JobCreationForm.css";
import DeleteIcon from "@material-ui/icons/Delete";
import ErrorOutileIcon from "@material-ui/icons/ErrorOutline";
import CircularProgress from "@material-ui/core/CircularProgress";
import GetAppIcon from "@material-ui/icons/GetApp";
// Import React FilePond
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
// Import FilePond styles
import "filepond/dist/filepond.min.css";

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

class JobCreationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editJob: false,
      editDisabled: false,
      editBidDurationDisabled: false,
      jobStatus: "",
      currentStatus: "",
      currentStatusId: "",

      states: States,
      surveyTypes: [],

      jobTitle: "",
      surveyType: "null",
      otherSurveyType: "null",
      bidStart: "",
      bidEnd: "",
      dueDate: "",
      bidDuration: "",
      taxMapId: "",
      address: "",
      state: "null",
      zipCode: "",
      certifiersName: "",
      deed: false,
      fileMap: false,
      preSurveys: false,
      takingAndEasements: false,
      files: [],
      documents: [],
      description: "",

      jobStatusId: "",

      minDate: "",

      jobTitleEmpty: false,
      surveyTypeEmpty: false,
      otherSurveyTypeEmpty: false,
      bidStartEmpty: false,
      bidEndEmpty: false,
      dueDateEmpty: false,
      bidDurationEmpty: false,
      taxMapIdEmpty: false,
      addressEmpty: false,
      stateEmpty: false,
      zipCodeEmpty: false,
      certifiersNameEmpty: false,
      descriptionEmpty: false,

      bidStartMinus: false,
      bidEndMinus: false,
      bidDurationMinus: false,
      zipCodeMinus: false,

      bidRangeNegative: false,

      isCreationLoading: false,
      isPostLoading: false,
      isSaveLoading: false,
      isSaveNPostLoading: false,

      isSubmitted: false,
      userCreationSuccess: true,

      submitDisabled: false,
      submitPostDisabled: false,

      isDeleted: false,
      successMsg: "",
      errMsg: "",
      isDownloaded: true,
    };
  }

  componentDidMount() {
    this.currentDay();
    this.setState({ editJob: this.props.editJob });
    if (this.props.editJob) {
      this.editData();
    }
    this.loadSurveyTypes();
  }

  loadSurveyTypes = () => {
    API.get("job/survey_types")
      .then((res) => {
        this.setState({ surveyTypes: res.data.response });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };

  currentDay = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    today = yyyy + "-" + mm + "-" + dd;
    this.setState({ minDate: today });
  };

  inputHandleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    this.setState(
      {
        [name]: value,
        [`${name}Empty`]: false,
      },
      () => this.checkMinus(name, value)
    );
  };

  dueDateHandle = (e) => {
    this.setState({
      dueDate: e.target.value,
      dueDateEmpty: false,
    });
  };

  dueDateHandlePrevent = (e) => {
    if (
      e.key === "ArrowUp" ||
      e.key === "ArrowDown" ||
      e.key === "ArrowLeft" ||
      e.key === "ArrowRight"
    ) {
      e.preventDefault();
    }
  };

  stateHandleChange = (e) => {
    this.setState({
      state: e.target.value,
      stateEmpty: false,
    });
  };

  surveyTypeHandleChange = (e) => {
    this.setState(
      {
        surveyType: e.target.value,
        surveyTypeEmpty: false,
      },
      () =>
        this.setState({
          otherSurveyType: this.state.surveyType === "Other" ? "" : "null",
        })
    );
  };

  handleChangeStatus = (e) => {
    this.setState({ jobStatus: e.target.value }, () =>
      this.getIdByStatus(this.state.jobStatus)
    );
  };

  getIdByStatus = (status) => {
    const statuses = [
      { id: 4, status: "In-progress" },
      { id: 5, status: "Verify" },
      { id: 6, status: "Completed" },
    ];
    statuses.forEach((each) => {
      if (each.status === status) {
        this.setState({ currentStatusId: each.id }, () =>
          this.changeStatus(this.state.currentStatusId)
        );
      }
    });
  };

  changeStatus = (statusId) => {
    API.post("job/status/" + this.props.jobId + "/" + statusId)
      .then((res) => {
        window.location.reload();
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };

  checkMinus = (name, value) => {
    if (name === "bidStart" && value !== null && value < 0) {
      this.setState({ bidStartMinus: true });
    } else if (name === "bidStart" && value !== null && value >= 0) {
      this.setState({ bidStartMinus: false });
    }
    if (name === "bidEnd" && value !== null && value < 0) {
      this.setState({ bidEndMinus: true });
    } else if (name === "bidEnd" && value !== null && value >= 0) {
      this.setState({ bidEndMinus: false });
    }
    if (name === "bidDuration" && value !== null && value < 0) {
      this.setState({ bidDurationMinus: true });
    } else if (name === "bidDuration" && value !== null && value >= 0) {
      this.setState({ bidDurationMinus: false });
    }
    if (name === "zipCode" && value !== null && value < 0) {
      this.setState({ zipCodeMinus: true });
    } else if (name === "zipCode" && value !== null && value >= 0) {
      this.setState({ zipCodeMinus: false });
    }
    this.bidRangeCheck();
  };

  bidRangeCheck = () => {
    if (this.state.bidEnd - this.state.bidStart < 0) {
      this.setState({ bidRangeNegative: true });
    } else {
      this.setState({ bidRangeNegative: false });
    }
  };

  selectDeed = (e) => {
    this.setState({ deed: e.target.checked });
  };
  selectFilemap = (e) => {
    this.setState({ fileMap: e.target.checked });
  };
  selectPreSurveys = (e) => {
    this.setState({ preSurveys: e.target.checked });
  };
  selectTakingAndEasements = (e) => {
    this.setState({ takingAndEasements: e.target.checked });
  };

  editData = () => {
    API.post("job/title/" + this.props.jobId)
      .then((res) => {
        this.loadSurveyTypes();
        const jobDetails = res.data.response.job[0];
        var dueDate = jobDetails.due_date.split(" ")[0];
        this.setState({
          editDisabled:
            jobDetails.job_status === "Created" ||
            jobDetails.job_status === "Expired" ||
            jobDetails.job_status === "Posted"
              ? false
              : true,
          editBidDurationDisabled:
            jobDetails.job_status === "Created" ||
            jobDetails.job_status === "Posted" ||
            jobDetails.job_status === "Expired"
              ? false
              : true,
          jobStatus: jobDetails.job_status,
          jobTitle: jobDetails.name,
          surveyType: jobDetails.survey_type_name,
          otherSurveyType: jobDetails.other_survey_type,
          bidStart: jobDetails.min_bid,
          bidEnd: jobDetails.max_bid,
          dueDate: dueDate,
          bidDuration: jobDetails.duration,
          taxMapId: jobDetails.tax_map_id,
          address: jobDetails.address,
          state: jobDetails.state,
          zipCode: jobDetails.zip_code,
          certifiersName: jobDetails.certifier_name,
          deed: jobDetails.deed,
          fileMap: jobDetails.filemap,
          preSurveys: jobDetails.pre_survey,
          takingAndEasements: jobDetails.taking_easements,
          description: jobDetails.description,
          documents: jobDetails.documents,
        });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };

  submitJobCreation = (e, status) => {
    e.preventDefault();

    this.setState({
      submitDisabled: true,
      submitPostDisabled: true,
    });

    if (status === "create") {
      this.setState({ isCreationLoading: true });
    } else if (status === "post") {
      this.setState({ isPostLoading: true });
    } else if (status === "save") {
      this.setState({ isSaveLoading: true });
    } else {
      this.setState({ isSaveNPostLoading: true });
    }

    const jobData = {
      jobTitle: this.state.jobTitle,
      bidStart: this.state.bidStart,
      bidEnd: this.state.bidEnd,
      dueDate: this.state.dueDate,
      bidDuration: this.state.bidDuration,
      taxMapId: this.state.taxMapId,
      address: this.state.address,
      zipCode: this.state.zipCode,
      certifiersName: this.state.certifiersName,
      description: this.state.description,
    };

    Object.keys(jobData).forEach((key) => {
      if (jobData[key] === "") {
        this.setState({
          [`${key}Empty`]: true,
        });
      } else {
        this.setState({
          [`${key}Empty`]: false,
        });
      }
    });
    if (this.state.state === "null") {
      this.setState({
        stateEmpty: true,
      });
    } else {
      this.setState({
        stateEmpty: false,
      });
    }
    if (this.state.surveyType === "null") {
      this.setState({
        surveyTypeEmpty: true,
      });
    } else {
      this.setState({
        surveyTypeEmpty: false,
      });
    }
    if (this.state.otherSurveyType === "") {
      this.setState({
        otherSurveyTypeEmpty: true,
      });
    } else {
      this.setState({
        otherSurveyTypeEmpty: false,
      });
    }

    var surveyTypeId = "";
    this.state.surveyTypes.forEach((each) => {
      if (this.state.surveyType === each.name) {
        surveyTypeId = each.id;
      }
    });

    const sendData = {
      name: this.state.jobTitle,
      survey_type: surveyTypeId,
      other_survey_type: this.state.otherSurveyType,
      min_bid: this.state.bidStart,
      max_bid: this.state.bidEnd,
      due_date: this.state.dueDate,
      duration: this.state.bidDuration,
      tax_map_id: this.state.taxMapId,
      address: this.state.address,
      state: this.state.state,
      zip_code: this.state.zipCode,
      certifier_name: this.state.certifiersName,
      // deed: this.state.deed,
      // filemap: this.state.fileMap,
      // pre_survey: this.state.preSurveys,
      // taking_easements: this.state.takingAndEasements,
      deed: this.state.deed ? "1" : "0",
      filemap: this.state.fileMap ? "1" : "0",
      pre_survey: this.state.preSurveys ? "1" : "0",
      taking_easements: this.state.takingAndEasements ? "1" : "0",
      description: this.state.description,
      // files: this.state.files,
      job_status_id: status === "create" ? 1 : status === "save" ? 1 : 2,
    };

    // =============================================
    // ===== create formdata for file transfer =====
    // =============================================
    var formData_requestPayload = new FormData();
    Object.keys(sendData).forEach((key) => {
      formData_requestPayload.append(key, sendData[key]);
    });
    this.state.files.map((file, i) => {
      formData_requestPayload.append("files[]", file, file.name);
      return 0;
    });
    formData_requestPayload.forEach((val, name) => {
      // console.log(val, name);
    });

    if (
      this.state.jobTitle !== "" &&
      this.state.surveyType !== "null" &&
      this.state.otherSurveyType !== "" &&
      this.state.bidStart !== "" &&
      !(this.state.bidStart < 0) &&
      !(parseInt(this.state.bidStart, 10) > parseInt(this.state.bidEnd, 10)) &&
      this.state.bidEnd !== "" &&
      !(this.state.bidEnd < 0) &&
      this.state.dueDate !== "" &&
      this.state.bidDuration !== "" &&
      !(this.state.bidDuration < 0) &&
      this.state.taxMapId !== "" &&
      this.state.address !== "" &&
      this.state.state !== "null" &&
      !(this.state.zipCode < 0) &&
      this.state.zipCode !== "" &&
      this.state.certifiersName !== "" &&
      this.state.description !== ""
    ) {
      const url = this.state.editJob
        ? this.state.jobStatus === "Created" ||
          this.state.jobStatus === "Expired"
          ? "job/create/" + this.props.jobId + "/0"
          : this.state.jobStatus === "Posted"
          ? "job/create/" + this.props.jobId + "/0"
          : "job/create/0/0"
        : "job/create/0/0";

      // API.post(url, sendData)
      API.post(url, formData_requestPayload)
        .then((res) => {
          this.setState({
            isCreationLoading: false,
            isPostLoading: false,
            isSaveLoading: false,
            isSaveNPostLoading: false,
            submitDisabled: false,
            submitPostDisabled: false,
          });
          this.showCreationMessage(true);
          this.clearAllFields();
        })
        .catch((err) => {
          console.log("AXIOS ERROR: ", err);
          this.setState({
            isCreationLoading: false,
            isPostLoading: false,
            isSaveLoading: false,
            isSaveNPostLoading: false,
            submitDisabled: false,
            submitPostDisabled: false,
          });
          this.showCreationMessage(false);
        });
    } else {
      this.setState({
        isCreationLoading: false,
        isPostLoading: false,
        isSaveLoading: false,
        isSaveNPostLoading: false,
        submitDisabled: false,
        submitPostDisabled: false,
      });
    }
  };

  clearAllFields = () => {
    this.setState({
      jobTitle: "",
      surveyType: "null",
      otherSurveyType: "null",
      bidStart: "",
      bidEnd: "",
      dueDate: "",
      bidDuration: "",
      taxMapId: "",
      address: "",
      state: "null",
      zipCode: "",
      certifiersName: "",
      deed: false,
      fileMap: false,
      preSurveys: false,
      takingAndEasements: false,
      description: "",

      jobTitleEmpty: false,
      surveyTypeEmpty: false,
      otherSurveyTypeEmpty: false,
      bidStartEmpty: false,
      bidEndEmpty: false,
      dueDateEmpty: false,
      bidDurationEmpty: false,
      taxMapIdEmpty: false,
      addressEmpty: false,
      stateEmpty: false,
      zipCodeEmpty: false,
      certifiersNameEmpty: false,

      submitDisabled: false,
      submitPostDisabled: false,
    });
  };

  showCreationMessage = (success) => {
    this.setState({
      isSubmitted: true,
      userCreationSuccess: success ? true : false,
    });

    // redirect user to job list after 1 second
    setTimeout(() => {
      this.setState({
        isSubmitted: false,
        userCreationSuccess: true,
      });
      success && (window.location.href = "/");
    }, 1000);
  };

  deleteJobModal = () => {
    API.get("job/delete/" + this.props.jobId)
      .then((res) => {
        console.log(res.data.response);
        this.setState({
          isDeleted: true,
          successMsg: res.data.response,
        });
        setTimeout(() => {
          window.location.href = "/";
        }, 1000);
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
        this.setState({
          errMsg: "Job deleted failed",
        });
      });
  };
  downloadDocument(docId, docName) {
    API.get(`job/document/` + docId + `/download`, {
      responseType: "blob",
    })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          const downloadUrl = window.URL.createObjectURL(new Blob([res.data]));

          const link = document.createElement("a");

          link.href = downloadUrl;
          link.download = docName;

          // const contentDisposition = res.headers["content-disposition"];

          // link.setAttribute("download", contentDisposition);
          document.body.appendChild(link);

          link.click();

          link.remove();
          this.setState({
            isDownloaded: true,
          });
        } else {
          this.setState({
            isDownloaded: false,
          });
        }
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
        this.setState({
          isDownloaded: false,
        });
      });
  }
  render() {
    const {
      editJob,
      states,
      jobStatus,
      isCreationLoading,
      isPostLoading,
      isSaveLoading,
      isSaveNPostLoading,
      isSubmitted,
      userCreationSuccess,
      surveyTypes,
      editDisabled,
      editBidDurationDisabled,
      submitDisabled,
      submitPostDisabled,
      isDeleted,
      successMsg,
      errMsg,
    } = this.state;

    // console.log(this.state.documents.length);
    return (
      <div className="detailCardRoot">
        <div className="headerCardMain userCreationMain">
          <div>
            <form>
              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">Job title*</div>
                  <div className="formInputDiv">
                    <input
                      type="text"
                      id="jobTitle"
                      name="jobTitle"
                      value={this.state.jobTitle}
                      className="textInput"
                      onChange={this.inputHandleChange}
                      disabled={editDisabled}
                    />
                    <div
                      className="ErrorLog"
                      style={{
                        display: this.state.jobTitleEmpty ? "block" : "none",
                      }}
                    >
                      <span>Job title is required</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow customRowSt">
                  <div className="formInputLabelNew">Survey type*</div>
                  <div className="customInputSt">
                    <select
                      id="surveyType"
                      name="surveyType"
                      value={this.state.surveyType}
                      className="textInput"
                      onChange={this.surveyTypeHandleChange}
                      disabled={editDisabled}
                    >
                      <option value={"null"}>Select</option>
                      {surveyTypes.map((type) => {
                        return (
                          <option value={type.name} key={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                    <div
                      className="ErrorLog"
                      style={{
                        display: this.state.surveyTypeEmpty ? "block" : "none",
                      }}
                    >
                      <span>Survey type is required</span>
                    </div>
                  </div>
                </div>
                <div className="formInnerRow customRowBd">
                  <div className="customInnerRowDiv desktopDiv">
                    <div className="formInputLabelNewHalfCustom">
                      Bid range ($)*
                    </div>
                    <div className="formInputDiv customInput">
                      <input
                        type="number"
                        id="bidStart"
                        name="bidStart"
                        value={this.state.bidStart}
                        className="textInput"
                        onChange={this.inputHandleChange}
                        maxLength="7"
                        disabled={editDisabled}
                      />
                      <div
                        className="ErrorLog"
                        style={{
                          display: this.state.bidStartMinus ? "block" : "none",
                        }}
                      >
                        <span>Minus values are not allowed</span>
                      </div>
                    </div>
                    <span style={{ float: "left" }}>&nbsp;-&nbsp;</span>
                    <div className="formInputDiv customInput">
                      <input
                        type="number"
                        id="bidEnd"
                        name="bidEnd"
                        value={this.state.bidEnd}
                        className="textInput"
                        onChange={this.inputHandleChange}
                        maxLength="7"
                        disabled={editDisabled}
                      />
                      <div
                        className="ErrorLog"
                        style={{
                          display: this.state.bidEndMinus ? "block" : "none",
                        }}
                      >
                        <span>Minus values are not allowed</span>
                      </div>
                    </div>
                    <div
                      className="ErrorLog bidRangeErr"
                      style={{
                        display:
                          this.state.bidEndEmpty || this.state.bidStartEmpty
                            ? "block"
                            : "none",
                      }}
                    >
                      <span>Bid range is required</span>
                    </div>
                    <div
                      className="ErrorLog bidRangeErr"
                      style={{
                        display: this.state.bidRangeNegative ? "block" : "none",
                      }}
                    >
                      <span>Bid range should be a positive value</span>
                    </div>
                  </div>
                  <div className="innerRowDiv mobileDiv">
                    <div className="formInputLabelNewHalfMax">
                      Bid range ($)*
                    </div>
                    <div className="formInputDiv customInputMax">
                      <input
                        type="number"
                        id="bidStart"
                        name="bidStart"
                        value={this.state.bidStart}
                        className="textInput"
                        onChange={this.inputHandleChange}
                        maxLength="7"
                        placeholder="Min bid"
                        disabled={editDisabled}
                      />
                      <div
                        className="ErrorLog"
                        style={{
                          display: this.state.bidStartMinus ? "block" : "none",
                        }}
                      >
                        <span>Minus values are not allowed</span>
                      </div>
                    </div>
                    <div className="formInputDiv customInputMax">
                      <input
                        type="number"
                        id="bidEnd"
                        name="bidEnd"
                        value={this.state.bidEnd}
                        className="textInput"
                        onChange={this.inputHandleChange}
                        maxLength="7"
                        placeholder="Max bid"
                        disabled={editDisabled}
                      />
                      <div
                        className="ErrorLog"
                        style={{
                          display: this.state.bidEndMinus ? "block" : "none",
                        }}
                      >
                        <span>Minus values are not allowed</span>
                      </div>
                    </div>
                    <div
                      className="ErrorLog"
                      style={{
                        display:
                          this.state.bidEndEmpty || this.state.bidStartEmpty
                            ? "block"
                            : "none",
                      }}
                    >
                      <span>Bid range is required</span>
                    </div>
                    <div
                      className="ErrorLog"
                      style={{
                        display: this.state.bidRangeNegative ? "block" : "none",
                      }}
                    >
                      <span>Bid range should be a positive value</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="formMainRow"
                style={{
                  display: this.state.surveyType === "Other" ? "block" : "none",
                }}
              >
                <div className="formInnerRow">
                  <div className="formInputLabelNew">Other survey type*</div>
                  <div className="formInputDiv">
                    <input
                      type="text"
                      id="otherSurveyType"
                      name="otherSurveyType"
                      value={this.state.otherSurveyType}
                      className="textInput"
                      onChange={this.inputHandleChange}
                      disabled={editDisabled}
                      placeholder="Enter the survey type here"
                    />
                    <div
                      className="ErrorLog"
                      style={{
                        display: this.state.otherSurveyTypeEmpty
                          ? "block"
                          : "none",
                      }}
                    >
                      <span>Other survey type is required</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow halfRow">
                  <div className="formInputLabelNew">
                    Required completion date*
                  </div>
                  <div className="halfInput">
                    <input
                      type="date"
                      id="dueDate"
                      name="dueDate"
                      value={this.state.dueDate}
                      className="textInput"
                      onChange={this.dueDateHandle}
                      min={this.state.minDate}
                      onKeyDown={this.dueDateHandlePrevent}
                      disabled={editDisabled}
                    />
                    <div
                      className="ErrorLog"
                      style={{
                        display: this.state.dueDateEmpty ? "block" : "none",
                      }}
                    >
                      <span>Job completion date is required</span>
                    </div>
                  </div>
                </div>
                <div className="formInnerRow halfRow">
                  <div className="innerRowDiv">
                    <div className="formInputLabelNewHalf desktopDiv">
                      Bid duration*
                    </div>
                    <div className="formInputLabelNewHalf mobileDiv">
                      Bid duration (Days)*
                    </div>
                    <div className="formInputDiv halfInput2">
                      <input
                        type="number"
                        id="bidDuration"
                        name="bidDuration"
                        value={this.state.bidDuration}
                        className="textInput"
                        onChange={this.inputHandleChange}
                        disabled={editBidDurationDisabled}
                      />
                      <div
                        className="ErrorLog"
                        style={{
                          display: this.state.bidDurationEmpty
                            ? "block"
                            : "none",
                        }}
                      >
                        <span>Bid duration is required</span>
                      </div>
                      <div
                        className="ErrorLog"
                        style={{
                          display: this.state.bidDurationMinus
                            ? "block"
                            : "none",
                        }}
                      >
                        <span>Minus values are not allowed</span>
                      </div>
                    </div>
                    <span className="subLabel desktopDiv">Day(s)</span>
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">Tax map ID*</div>
                  <div className="formInputDiv customInput2">
                    <input
                      type="text"
                      id="taxMapId"
                      name="taxMapId"
                      value={this.state.taxMapId}
                      className="textInput"
                      onChange={this.inputHandleChange}
                      disabled={editDisabled}
                    />
                    <div
                      className="ErrorLog"
                      style={{
                        display: this.state.taxMapIdEmpty ? "block" : "none",
                      }}
                    >
                      <span>Tax map ID is required</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">Address*</div>
                  <div className="formInputDiv">
                    <input
                      type="text"
                      id="address"
                      name="address"
                      value={this.state.address}
                      className="textInput"
                      onChange={this.inputHandleChange}
                      disabled={editDisabled}
                    />
                    <div
                      className="ErrorLog"
                      style={{
                        display: this.state.addressEmpty ? "block" : "none",
                      }}
                    >
                      <span>Address is required</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow halfRow">
                  <div className="formInputLabelNew">State*</div>
                  <div className="halfInput">
                    <select
                      id="state"
                      name="state"
                      value={this.state.state}
                      className="textInput"
                      onChange={this.stateHandleChange}
                      disabled={editDisabled}
                    >
                      <option value={"null"}>Select</option>
                      {states.map((state) => {
                        return (
                          <option value={state.name} key={state.name}>
                            {state.name}
                          </option>
                        );
                      })}
                    </select>
                    <div
                      className="ErrorLog"
                      style={{
                        display: this.state.stateEmpty ? "block" : "none",
                      }}
                    >
                      <span>State is required</span>
                    </div>
                  </div>
                </div>
                <div className="formInnerRow halfRow">
                  <div className="innerRowDiv">
                    <div className="formInputLabelNewHalf">Zip code*</div>
                    <div className="formInputDiv customInput3">
                      <input
                        type="number"
                        id="zipCode"
                        name="zipCode"
                        value={this.state.zipCode}
                        className="textInput"
                        onChange={this.inputHandleChange}
                        disabled={editDisabled}
                      />
                      <div
                        className="ErrorLog"
                        style={{
                          display: this.state.zipCodeEmpty ? "block" : "none",
                        }}
                      >
                        <span>Zip code is required</span>
                      </div>
                      <div
                        className="ErrorLog"
                        style={{
                          display: this.state.zipCodeMinus ? "block" : "none",
                        }}
                      >
                        <span>Minus values are not allowed</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">Certified to*</div>
                  <div className="formInputDiv">
                    <textarea
                      id="certifiersName"
                      name="certifiersName"
                      className="textInput maxHeight minHeight"
                      value={this.state.certifiersName}
                      onChange={this.inputHandleChange}
                      disabled={editDisabled}
                    ></textarea>
                    <div
                      className="ErrorLog"
                      style={{
                        display: this.state.certifiersNameEmpty
                          ? "block"
                          : "none",
                      }}
                    >
                      <span>Certified to is required</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelCustom">
                    Research information available
                  </div>
                  <div className="fillingInputs">
                    <div className="checkInputs">
                      <input
                        type="checkbox"
                        id="deed"
                        name="deed"
                        checked={this.state.deed}
                        className="textInput checkboxInput"
                        onChange={this.selectDeed}
                        disabled={editDisabled}
                      />
                      <span className="checkLabel">Deed</span>
                    </div>
                    <div className="checkInputs">
                      <input
                        type="checkbox"
                        id="fileMap"
                        name="fileMap"
                        checked={this.state.fileMap}
                        className="textInput checkboxInput"
                        onChange={this.selectFilemap}
                        disabled={editDisabled}
                      />
                      <span className="checkLabel">Filemap</span>
                    </div>
                    <div className="checkInputs2 extraMargin">
                      <input
                        type="checkbox"
                        id="preSurveys"
                        name="preSurveys"
                        checked={this.state.preSurveys}
                        className="textInput checkboxInput"
                        onChange={this.selectPreSurveys}
                        disabled={editDisabled}
                      />
                      <span className="checkLabel">Prior surveys</span>
                    </div>
                    <div className="checkInputs2">
                      <input
                        type="checkbox"
                        id="takingAndEasements"
                        name="takingAndEasements"
                        checked={this.state.takingAndEasements}
                        className="textInput checkboxInput"
                        onChange={this.selectTakingAndEasements}
                        disabled={editDisabled}
                      />
                      <span className="checkLabel">
                        Takings &amp; easements
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {this.state.editJob && this.state.documents.length > 0 ? (
                <div className="formMainRow">
                  <div className="formInnerRow">
                    <div className="maxWidth minMargin">Files</div>
                    <div className="maxWidth">
                      <div className="docContainer">
                        {this.state.documents.map((doc, i) => {
                          return (
                            <div className="docItem" key={i}>
                              <h3>{doc.file_name}</h3>
                              {/* <a
                                download={doc.file_name}
                                href={`${API}job/document/${doc.id}/download`}
                              > */}
                              <GetAppIcon
                                onClick={() =>
                                  this.downloadDocument(doc.id, doc.file_name)
                                }
                                style={{
                                  color: "#FFFFFF",
                                  cursor: "pointer",
                                }}
                              />
                              {/* </a> */}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="formInnerRow">
                    <div className="maxWidth">
                      <FilePond
                        allowFileTypeValidation={true}
                        acceptedFileTypes={[
                          "text/plain",
                          "application/pdf",
                          "application/doc",
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                          "application/msword",
                          "application/x-soffice",
                          "text/richtext",
                          "application/rtf",
                          "application/x-iwork-pages-sffpages",
                          "image/png",
                          "image/jpeg",
                        ]}
                        ref={(ref) => (this.pond = ref)}
                        files={this.state.files}
                        allowMultiple={true}
                        maxFiles={5}
                        onupdatefiles={(fileItems) => {
                          // Set currently active file objects to this.state
                          this.setState({
                            files: fileItems.map((fileItem) => fileItem.file),
                          });
                        }}
                      ></FilePond>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="formMainRow">
                  <div className="formInnerRow">
                    <div className="maxWidth minMargin">Files</div>
                    <div className="maxWidth">
                      <FilePond
                        ref={(ref) => (this.pond = ref)}
                        allowFileTypeValidation={true}
                        acceptedFileTypes={[
                          "text/plain",
                          "application/pdf",
                          "application/doc",
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                          "application/msword",
                          "application/x-soffice",
                          "text/richtext",
                          "application/rtf",
                          "application/x-iwork-pages-sffpages",
                          "image/png",
                          "image/jpeg",
                        ]}
                        files={this.state.files}
                        allowMultiple={true}
                        maxFiles={5}
                        onupdatefiles={(fileItems) => {
                          // Set currently active file objects to this.state
                          this.setState({
                            files: fileItems.map((fileItem) => fileItem.file),
                          });
                        }}
                        disabled={editDisabled}
                      ></FilePond>
                    </div>
                  </div>
                </div>
              )}

              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew maxWidth minMargin">
                    Description*
                  </div>
                  <div className="maxWidth">
                    <textarea
                      id="description"
                      name="description"
                      className="textInput maxHeight minHeight"
                      value={this.state.description}
                      onChange={this.inputHandleChange}
                      disabled={editDisabled}
                    ></textarea>
                    <div
                      className="ErrorLog"
                      style={{
                        display: this.state.descriptionEmpty ? "block" : "none",
                      }}
                    >
                      <span>Description is required</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="submitButtons">
                <div className="userCreationMessageDiv">
                  <div
                    className="userCreationMessage messageResponsive"
                    id="userCreationMessage"
                  >
                    {isSubmitted ? (
                      userCreationSuccess ? (
                        <div className="messageBody userCreationSuccessColor">
                          <div className="messageAction">
                            <ErrorOutileIcon />
                          </div>
                          <div className="userCreationSuccess">
                            Job has been created successfully
                          </div>
                        </div>
                      ) : (
                        <div className="messageBody userCreationFailColor">
                          <div className="messageAction">
                            <ErrorOutileIcon />
                          </div>
                          <div className="userCreationFail">Error</div>
                        </div>
                      )
                    ) : null}
                    {isDeleted ? (
                      <div className="messageBody userCreationSuccessColor">
                        <div className="messageAction">
                          <ErrorOutileIcon />
                        </div>
                        <div className="userCreationSuccess">{successMsg}</div>
                      </div>
                    ) : null}
                    {errMsg !== "" ? (
                      <div className="messageBody userCreationSuccessColor">
                        <div className="messageAction">
                          <ErrorOutileIcon />
                        </div>
                        <div className="userCreationSuccess">{errMsg}</div>
                      </div>
                    ) : null}
                  </div>
                  {(jobStatus === "Created" || jobStatus === "Posted") && (
                    <div
                      className="deleteJobDiv desktopDiv"
                      onClick={this.deleteJobModal}
                    >
                      <DeleteIcon />
                      <span>Delete</span>
                    </div>
                  )}
                  {editJob ? (
                    jobStatus === "Created" || jobStatus === "Posted" ? (
                      <div
                        className="createButtonsDiv"
                        // style={{
                        //   display: jobStatus === "Created" ? "flex" : "block",
                        // }}
                      >
                        <button
                          type="submit"
                          className="formSubmit jobCreateNewButton"
                          onClick={(e) => this.submitJobCreation(e, "save")}
                          style={{
                            float: jobStatus === "Created" ? "left" : "right",
                          }}
                          disabled={submitDisabled}
                        >
                          {isSaveLoading ? (
                            <CircularProgress className="circularColor3" />
                          ) : (
                            <div>
                              <span>Save</span>
                            </div>
                          )}
                        </button>
                        {/* {jobStatus === "Created"  && ( */}
                        <button
                          type="submit"
                          className="formSubmit jobPostButton"
                          onClick={(e) =>
                            this.submitJobCreation(e, "saveNpost")
                          }
                          disabled={submitPostDisabled}
                        >
                          {isSaveNPostLoading ? (
                            <CircularProgress className="circularColor2" />
                          ) : (
                            <div>
                              <span>Update &amp; post</span>
                            </div>
                          )}
                        </button>
                        {/* )} */}
                      </div>
                    ) : jobStatus === "Expired" ? (
                      <button
                        type="submit"
                        className="formSubmit jobPostButton"
                        onClick={(e) => this.submitJobCreation(e, "saveNpost")}
                        disabled={submitDisabled}
                      >
                        {isSaveNPostLoading ? (
                          <CircularProgress className="circularColor2" />
                        ) : (
                          <div>
                            <span>Update &amp; post</span>
                          </div>
                        )}
                      </button>
                    ) : (
                      <div>
                        <select
                          id="changeJobStatus"
                          name="changeJobStatus"
                          className="changeJobStatus"
                          value={jobStatus}
                          onChange={this.handleChangeStatus}
                        >
                          <option value="In-progress">In-progress</option>
                          <option value="Verify">Verify</option>
                          <option value="Completed">Accepted by client</option>
                        </select>
                      </div>
                    )
                  ) : (
                    <div className="createButtonsDiv">
                      <button
                        type="submit"
                        className="formSubmit jobCreateNewButton"
                        onClick={(e) => this.submitJobCreation(e, "create")}
                        disabled={submitDisabled}
                      >
                        {isCreationLoading ? (
                          <CircularProgress className="circularColor3" />
                        ) : (
                          <div>
                            <span>Create</span>
                          </div>
                        )}
                      </button>
                      <button
                        type="submit"
                        className="formSubmit jobPostButton"
                        onClick={(e) => this.submitJobCreation(e, "post")}
                        disabled={submitPostDisabled}
                      >
                        {isPostLoading ? (
                          <CircularProgress className="circularColor2" />
                        ) : (
                          <div>
                            <span>Create &amp; post</span>
                          </div>
                        )}
                      </button>
                    </div>
                  )}
                  {jobStatus === "Created" && (
                    <div
                      className="deleteJobDiv mobileDiv"
                      onClick={this.deleteJobModal}
                    >
                      <DeleteIcon />
                      <span>Delete</span>
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default JobCreationForm;



// WEBPACK FOOTER //
// ./src/pages/Jobs/JobCreationForm.js